import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Divider,
  IconButton,
  Tooltip
} from '@mui/material';
import { OpenInNew as OpenInSpotifyIcon } from '@mui/icons-material';
import { Playlist } from '../../models';
import AudioPlayer from '../music/AudioPlayer';

interface PlaylistDetailsProps {
  playlist: Playlist;
}

const PlaylistDetails: React.FC<PlaylistDetailsProps> = ({ playlist }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Playlist Details</Typography>
      <Card>
        <CardContent>
          <Typography variant="h5">{playlist.name}</Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {playlist.description || 'No description'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="body2">
              {playlist.tracks.length} tracks • Created by {playlist.owner.displayName}
            </Typography>
            <Tooltip title="Open in Spotify">
              <IconButton 
                size="small"
                onClick={() => window.open(`https://open.spotify.com/playlist/${playlist.id}`, '_blank')}
              >
                <OpenInSpotifyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="subtitle1" gutterBottom>Tracks:</Typography>
          {playlist.tracks.map((track, index) => (
            <Box key={track.id} sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ mr: 1, minWidth: '20px' }}>
                  {index + 1}.
                </Typography>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body2">{track.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {track.artists.map(artist => artist.name).join(', ')}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ ml: 4, mt: 0.5 }}>
                <AudioPlayer
                  previewUrl={track.previewUrl}
                  trackName={track.name}
                  artistName={track.artists.map(artist => artist.name).join(', ')}
                  spotifyUri={track.uri}
                />
              </Box>
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PlaylistDetails;
